import { render, staticRenderFns } from "./WaiterJudgeTemplateItem.vue?vue&type=template&id=c41cae3c&scoped=true&lang=pug"
import script from "./WaiterJudgeTemplateItem.vue?vue&type=script&lang=ts"
export * from "./WaiterJudgeTemplateItem.vue?vue&type=script&lang=ts"
import style0 from "./WaiterJudgeTemplateItem.vue?vue&type=style&index=0&id=c41cae3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c41cae3c",
  null
  
)

export default component.exports